.container {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-big);
  margin-bottom: var(--space-big);
  margin-top: var(--space-small);
}

.center {
  justify-content: center;
}
